/**
 * Native User Timing for bootstrap phases, visible in devtools and RUM.
 * Optional calls keep it a no-op where the API is unavailable.
 */
export const mark = (name: string) => performance.mark?.(`guac:${name}`);

export const measure = (name: string, startMark: string, endMark: string) => {
  try {
    performance.measure?.(`guac:${name}`, `guac:${startMark}`, `guac:${endMark}`);
  } catch {
    // a phase can be skipped (logout short-circuit, bootstrap failure), leaving a mark unset
  }
};
